'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _OrderItem = require('./OrderItem.js');

var _OrderItem2 = _interopRequireDefault(_OrderItem);

var _availability = require('availability');

var availability = _interopRequireWildcard(_availability);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CONDITIONS = {
    'true': function _true() {
        return true;
    },
    'false': function _false() {
        return false;
    },
    'not': function not(params) {
        var condition = params.condition;
        return !checkCondition(_lodash2.default.extend(params, { condition: condition.condition }));
    },
    'and': function and(params) {
        var condition = params.condition;
        return _lodash2.default.every(condition.conditions, function (_condition) {
            return checkCondition(_lodash2.default.extend(params, { condition: _condition }));
        });
    },
    'or': function or(params) {
        var condition = params.condition;
        return _lodash2.default.some(condition.conditions, function (_condition) {
            return checkCondition(_lodash2.default.extend(params, { condition: _condition }));
        });
    },
    'order_delivery_time': function order_delivery_time(params) {
        var condition = params.condition;
        var deliveryTime = params.deliveryTime;

        var util = new availability.AvailabilityIterator({ cal: deliveryTime, availability: condition.availability || {} });
        if (!util.hasNext()) {
            return false;
        }

        var status = util.next();
        return !(status.status === 'unavailable');
    },
    'order_delivery_type': function order_delivery_type(params) {
        var condition = params.condition;
        var deliveryType = params.deliveryType;

        return condition.deliveryType === deliveryType;
    },
    'order_items_price': function order_items_price(params) {
        var condition = params.condition;
        var orderItems = params.orderItems;

        var totalApplicableItems = 0;
        _lodash2.default.each(orderItems, function (orderItem) {
            totalApplicableItems += _OrderItem2.default.getTotalPrice({ orderItem: orderItem });
        });

        if (condition.min && totalApplicableItems < condition.min) return false;
        if (condition.max && totalApplicableItems > condition.max) return false;

        return true;
    },
    'order_platform': function order_platform(params) {
        var condition = params.condition;
        var platform = params.platform;

        return platform === condition.platform;
    },
    'order_source': function order_source(params) {
        var condition = params.condition;
        var source = params.source;

        return source === condition.source;
    },
    'user_charge_usage': function user_charge_usage() {
        throw new Error('user_charge_usage not implemented yet.');
    }
};

function checkCondition(params) {
    var condition = params.condition;

    var func = CONDITIONS[condition.type] || function () {
        return false;
    };
    return func(params);
}

var OPERATORS = {
    'value': function value(params) {
        var operator = params.operator;
        return operator.value;
    },
    'min': function min(params) {
        var operator = params.operator;

        return _lodash2.default.min(_lodash2.default.map(operator.operators, function (_operator) {
            return calculateOperator(_lodash2.default.extend(params, { operator: _operator }));
        }));
    },
    'max': function max(params) {
        var operator = params.operator;

        return _lodash2.default.max(_lodash2.default.map(operator.operators, function (_operator) {
            return calculateOperator(_lodash2.default.extend(params, { operator: _operator }));
        }));
    },
    'multiply': function multiply(params) {
        var operator = params.operator;

        var numerators = 1;
        var denominators = 1;

        _lodash2.default.each(operator.numerators, function (_operator) {
            numerators *= calculateOperator(_lodash2.default.extend(params, { operator: _operator }));
        });

        _lodash2.default.each(operator.denominators, function (_operator) {
            denominators *= calculateOperator(_lodash2.default.extend(params, { operator: _operator }));
        });

        var result = numerators / denominators;

        return Math.sign(result) * Math.floor(Math.abs(result) + 0.5);
    },
    'count_items': function count_items(params) {
        var operator = params.operator;
        var orderItems = params.orderItems;
        var orderCharges = params.orderCharges;

        var total = 0;

        _lodash2.default.each(orderItems, function (orderItem) {
            if (isApplicableItem(orderItem.itemId, operator.items)) {
                total += orderItem.count || 1;
            }
        });

        _lodash2.default.each(orderCharges, function (orderCharge) {
            if (isApplicableItem(orderCharge.chargeId, operator.charges)) {
                total++;
            }
        });

        return total;
    },
    'sum': function sum(params) {
        var operator = params.operator;

        var result = 0;

        _lodash2.default.each(operator.operators, function (_operator) {
            result += calculateOperator(_lodash2.default.extend(params, { operator: _operator }));
        });

        return result;
    },
    'sum_prices': function sum_prices(params) {
        var operator = params.operator;
        var orderItems = params.orderItems;
        var orderCharges = params.orderCharges;

        // Get all applicable items' price in a sorted list
        var applicableItems = _lodash2.default.flatten(_lodash2.default.compact(_lodash2.default.map(orderItems, function (orderItem) {
            if (!isApplicableItem(orderItem.itemId, operator.items)) {
                return null;
            }
            return _lodash2.default.map(_lodash2.default.range(orderItem.count || 1), function () {
                return _OrderItem2.default.getTotalPrice({ orderItem: orderItem }) / (orderItem.count || 1);
            });
        })));

        // Get all applicable items' price in a sorted list
        var applicableCharges = _lodash2.default.flatten(_lodash2.default.compact(_lodash2.default.map(orderCharges, function (orderCharge) {
            if (!isApplicableItem(orderCharge.chargeId, operator.charges)) {
                return null;
            }
            return orderCharge.amount;
        })));

        var applicable = (0, _lodash2.default)(applicableItems).concat(applicableCharges).value().sort(function (x, y) {
            return x - y;
        });

        // Re-calculate Y
        var max = Math.min(operator.maxCount || Number.MAX_VALUE, applicable.length);

        // Ensure there's the right amount of items
        if (max < 0) return 0;

        return _lodash2.default.reduce(applicable.splice(0, max), function (memo, num) {
            return memo + num;
        }, 0);
    }
};

function calculateOperator(params) {
    var operator = params.operator;

    var func = OPERATORS[operator.type] || function () {
        return 0;
    };
    var ret = func(params);

    return ret;
}

function isApplicableItem(itemId, idsFilter) {
    if (!idsFilter) return false;

    if ((idsFilter.type || 'include') === 'include') {
        return _lodash2.default.includes(idsFilter.ids, itemId);
    } else {
        return !_lodash2.default.includes(idsFilter.ids, itemId);
    }
}

exports.default = {

    isApplicable: function isApplicable(params) {
        var charge = params.charge;
        var deliveryTime = params.deliveryTime;
        var deliveryType = params.deliveryType || '';
        var orderItems = params.orderItems || [];
        var source = params.source;
        var platform = params.platform;

        if (charge.state === 'closed') return false;

        return checkCondition({ condition: charge.condition, deliveryTime: deliveryTime, deliveryType: deliveryType,
            orderItems: orderItems, source: source, platform: platform });
    },

    isDisplayable: function isDisplayable(params) {
        var charge = params.charge;
        var deliveryTime = params.deliveryTime;
        var deliveryType = params.deliveryType || '';
        var orderItems = params.orderItems || [];
        var source = params.source;
        var platform = params.platform;

        if (charge.state === 'closed') return false;

        return checkCondition({ condition: charge.displayCondition, deliveryTime: deliveryTime, deliveryType: deliveryType,
            orderItems: orderItems, source: source, platform: platform });
    },

    calculateAmount: function calculateAmount(params) {
        var charge = params.charge;
        var orderItems = params.orderItems || [];
        var orderCharges = params.orderCharges || [];
        var extraCost = params.extraCost;

        if (!this.isApplicable(params)) return 0;

        return calculateOperator({ operator: charge.operator, orderItems: orderItems, orderCharges: orderCharges,
            extraCost: extraCost });
    }
};